export var IdServer = {
  TokenType: {
    None: 0,
    Default: 1,
    Refresh: 2,
    Integration: 3,
    Anonymous: 4,
    Sso: 5,
    SSOLogin: 6,
  }
}
